module.exports = __webpack_public_path__ + "media/components/incentive/static/remove-7682178bf57ac7badbf2d86b63e879fb.svg";